<template lang="pug">
assign(:ID="ID" :value="configurationID")
  template(v-slot:activator="{on}")
    div(v-on="on").text-center {{ currentConfiguration }}
</template>

<script>
import {mapGetters} from "vuex"

import Assign from "./CMAssignCourseConfiguration.vue"
export default {
  props: {
    ID: Number,
    configurationID: Number,
  },
  computed: {
    ...mapGetters({
      locations: 'locationConfigurations/items'
    }),

    currentConfiguration() {
      if(!this.locations.length) return '-'
      let item = this.locations.find(location => location.id === this.configurationID)
      if(!item) return '-'
      return `${item.name}`
    }
  },

  components: {
    assign: Assign
  }
}
</script>
